import { useForm, Controller } from "react-hook-form";
import { FormContainer, TextInput, SelectInput, CountrySelector } from "../../components/shared";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { BASIC_LOGIN_APP_LIST, RegexPattern, clearCache, updateCache } from "../../utils";

const BasicLoginConfigForm = ({ query, formType, formData }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            ...formData,
            isEnabled: Number(formData?.isEnabled) === 1,
        },
    });

    const { submitMutation, loading } = useGlobalMutation(query, (cache, result) => {
        const newData = result?.data?.editBasicAuth?.basicAuth;
        formType !== "update" && clearCache(cache, "allBasicAuths");
        formType === "update" && newData && updateCache(cache, newData.id, newData, "BasicAuth");
    });

    const submitAction = handleSubmit(async (data) => {
        const variables =
            formType === "update"
                ? {
                      ...data,
                      country: data.country || "",
                      isEnabled: data.isEnabled ? 1 : 0,
                  }
                : {
                      basicAuth: {
                          ...data,
                          country: data.country || "",
                          isEnabled: data.isEnabled ? 1 : 0,
                      },
                  };

        const dataPath =
            formType === "update" ? "editBasicAuth.basicAuth" : "insertBasicAuth.basicAuth";

        const successMessage = `Basic Login  ${
            formType === "update" ? "Updated" : "Created"
        } Successfully`;

        const isResultNull = await submitMutation(variables, dataPath, successMessage);

        isResultNull === null && formType !== "update" && reset();
    });

    return (
        <FormContainer submitAction={submitAction} loading={loading}>
            <div className="row">
                <div className="col-md-6">
                    <SelectInput
                        id="appName"
                        labelText="App Name"
                        options={BASIC_LOGIN_APP_LIST}
                        {...register("appName", {
                            required: true,
                        })}
                        isInvalid={!!errors.appName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="basicLoginDomainName"
                        labelText="Domain Name"
                        {...register("basicLoginDomainName", {
                            required: true,
                            pattern: RegexPattern.DOMAIN,
                        })}
                        isInvalid={!!errors.basicLoginDomainName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="basicLoginRootPath"
                        labelText="Basic Login Root Path"
                        {...register("basicLoginRootPath", {
                            required: true,
                            pattern: RegexPattern.PATH,
                        })}
                        isInvalid={!!errors.basicLoginRootPath}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="basicAuthPath"
                        labelText="Basic Login Path"
                        {...register("basicAuthPath", {
                            required: true,
                            pattern: RegexPattern.PATH,
                        })}
                        isInvalid={!!errors.basicAuthPath}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <Controller
                        name="country"
                        render={({ field: { onChange, value }, ref }) => (
                            <CountrySelector
                                id="country"
                                country={value || ""}
                                labelText="Country"
                                selectCountry={onChange}
                                {...register("country", {})}
                                ref={ref}
                            />
                        )}
                        control={control}
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="forogtPasswordPath"
                        labelText="Forgot Password Path"
                        {...register("forogtPasswordPath", {
                            required: true,
                            pattern: RegexPattern.PATH,
                        })}
                        isInvalid={!!errors.forogtPasswordPath}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="resetPasswordPath"
                        labelText="Reset Password Path"
                        {...register("resetPasswordPath", {
                            required: true,
                            pattern: RegexPattern.PATH,
                        })}
                        isInvalid={!!errors.resetPasswordPath}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="changePasswordPath"
                        labelText="Change Password Path"
                        {...register("changePasswordPath", {
                            required: true,
                            pattern: RegexPattern.PATH,
                        })}
                        isInvalid={!!errors.changePasswordPath}
                        required
                    />
                </div>

                <div className="col-12">
                    <input
                        className="mr-2"
                        type="checkbox"
                        id="isEnabled"
                        {...register("isEnabled")}
                    />
                    <label className="ms-2" htmlFor="isEnabled">
                        Enable Basic Login Configuration
                    </label>
                </div>
            </div>
        </FormContainer>
    );
};

export default BasicLoginConfigForm;
